import { lazy } from "react";

export const BrandActivePromotionDetailPage = lazy(
  () => import("../pages/BrandActivePromotionDetailPage")
);
export const BrandPromotionsPerformancePage = lazy(
  () => import("../pages/BrandPromotionsPerformancePage")
);
export const BrandFundedPromoModalPage = lazy(
  () => import("../pages/BrandFundedPromoModalPage")
);
export const CommunityLibraryPage = lazy(
  () => import("../pages/CommunityLibraryPage")
);
export const FauxDSPage = lazy(() => import("../pages/FauxDSPage"));
export const FeedPage = lazy(() => import("../platform/pages/feed/Page"));
export const GettingStartedPage = lazy(
  () => import("../pages/GettingStartedPage")
);
export const ImageCatalogPage = lazy(() => import("../pages/ImageCatalogPage"));
export const LoginPage = lazy(() =>
  import("../pages/LoginPage").then((m) => ({ default: m.LoginPage }))
);
export const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));
export const PlaybookPage = lazy(() => import("../pages/PlaybookPage"));
export const PlaygroundPages = lazy(() =>
  import("../platform/pages/Page").then((m) => ({
    default: m.PlaygroundPages,
  }))
);
